"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactRedux = require("react-redux");
var _comparisonActions = require("../../store/comparison/comparisonActions");
var _comparisonSelectors = require("../../store/comparison/comparisonSelectors");
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var _useComparison2 = _interopRequireDefault(require("./useComparison"));
var _useComparisonSettings = _interopRequireDefault(require("./useComparisonSettings"));
var _lodash = _interopRequireDefault(require("lodash.uniqby"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var handleMultipleValueSpecs = function handleMultipleValueSpecs(product, specLabel) {
  var uniqueSpecValues;
  var specValues = product.variants.map(function (variant) {
    var _variant$specLabel, _variant$specLabel2, _variant$specLabel3;
    return {
      value: (_variant$specLabel = variant[specLabel]) === null || _variant$specLabel === void 0 ? void 0 : _variant$specLabel.value[0].value,
      valueType: (_variant$specLabel2 = variant[specLabel]) === null || _variant$specLabel2 === void 0 ? void 0 : _variant$specLabel2.value[0].unitOfMeasure,
      valueText: (_variant$specLabel3 = variant[specLabel]) === null || _variant$specLabel3 === void 0 ? void 0 : _variant$specLabel3.valueText
    };
  });
  var isSameValueType = specValues.length > 1 && specValues.every(function (_ref) {
    var valueType = _ref.valueType;
    return valueType === specValues[0].valueType;
  });
  var specValueText;
  if (isSameValueType) {
    specValueText = getMultipleValuesWithSameUnit(specValues);
  } else {
    uniqueSpecValues = (0, _lodash.default)(specValues, function (obj) {
      return obj.valueText;
    });
    var textValues = uniqueSpecValues.map(function (el) {
      return el.valueText;
    });
    specValueText = "".concat(uniqueSpecValues.length > 0 ? textValues.join('/') : '-');
  }
  return specValueText;
};
var getMultipleValuesWithSameUnit = function getMultipleValuesWithSameUnit(specValues) {
  var valuesText = '';
  specValues.forEach(function (variant, index) {
    if (!valuesText.includes(variant.value) && valuesText.length !== 0) {
      valuesText += "/".concat(variant.value);
    }
    if (valuesText.length === 0) {
      valuesText = "".concat(variant.value);
    }
    if (index === specValues.length - 1) {
      valuesText += " ".concat(variant.valueType);
    }
  });
  return valuesText;
};
var useComparisonSpecs = function useComparisonSpecs() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var characteristicGroups = (0, _reactRedux.useSelector)(_widgetSelectors.selectProductCatalog).specGroups;
  var _useComparison = (0, _useComparison2.default)(),
    products = _useComparison.products;
  var specs = (0, _reactRedux.useSelector)(_comparisonSelectors.selectComparisonSpecs);
  var _useComparisonSetting = (0, _useComparisonSettings.default)(),
    multipleValueCharacteristics = _useComparisonSetting.multipleValueCharacteristics;
  (0, _react.useEffect)(function () {
    var productList = Object.values(products);
    var colorSpecs = {};
    productList.forEach(function (product) {
      if (!(product !== null && product !== void 0 && product.filterTree)) return;
      var colorValues = product.selectedVariant.characteristics.find(function (spec) {
        return spec.name === 'color';
      }).value.filter(function (color) {
        var _color$value;
        var rgx = /#\b[0-9A-Fa-f]{6}\b\s*\|\s*(.*)/;
        return rgx.test((_color$value = color.value) === null || _color$value === void 0 ? void 0 : _color$value.trim());
      }).map(function (value) {
        var _value$value$split = value.value.split('|'),
          _value$value$split2 = _slicedToArray(_value$value$split, 2),
          color = _value$value$split2[0],
          text = _value$value$split2[1];
        return {
          colorValue: color,
          text: text
        };
      });
      colorSpecs[product.productId] = _toConsumableArray(colorValues);
    });
    var colorGroup = {
      label: 'Colors',
      specs: [{
        label: 'color',
        values: colorSpecs
      }]
    };

    //grouped chars
    var specGroups = [];
    characteristicGroups === null || characteristicGroups === void 0 ? void 0 : characteristicGroups.forEach(function (group) {
      var specGroup = {
        label: group.name,
        specs: _toConsumableArray(group.characteristics.map(function (spec) {
          return {
            label: spec.name,
            values: {}
          };
        }))
      };
      productList.forEach(function (product) {
        var _product$variants$, _product$variants$$gr;
        var samegroup = product === null || product === void 0 ? void 0 : (_product$variants$ = product.variants[0]) === null || _product$variants$ === void 0 ? void 0 : (_product$variants$$gr = _product$variants$.groupedCharacteristics) === null || _product$variants$$gr === void 0 ? void 0 : _product$variants$$gr.find(function (productGroup) {
          return productGroup.name === specGroup.label;
        });
        specGroup.specs.forEach(function (spec) {
          var _samegroup$specs;
          var productSpec = samegroup === null || samegroup === void 0 ? void 0 : (_samegroup$specs = samegroup.specs) === null || _samegroup$specs === void 0 ? void 0 : _samegroup$specs.find(function (productSpec) {
            return productSpec.name === spec.label;
          });
          var value;
          //This section handles values that differ between products and is currently empty (can be used in the future if needed)
          if (multipleValueCharacteristics !== null && multipleValueCharacteristics !== void 0 && multipleValueCharacteristics.includes(spec.label)) {
            var specValue = handleMultipleValueSpecs(product, spec.label);
            value = [{
              text: "".concat(specValue),
              subText: spec.label
            }];
          } else {
            var _product$selectedVari;
            value = [_objectSpread({
              text: productSpec === null || productSpec === void 0 ? void 0 : productSpec.valueText,
              subText: spec.label
            }, spec.label === 'entertainment' && {
              duration: product === null || product === void 0 ? void 0 : (_product$selectedVari = product.selectedVariant) === null || _product$selectedVari === void 0 ? void 0 : _product$selectedVari.price.durationAmount
            })];
          }
          spec.values[product.productId] = value;
        });
      });
      specGroups.push(specGroup);
    });
    dispatch((0, _comparisonActions.setComparisonSpecs)([colorGroup].concat(specGroups)));
  }, [products]);
  return {
    specGroups: specs
  };
};
var _default = useComparisonSpecs;
exports.default = _default;